import React, { useContext } from 'react';
import { AccessibilityContext } from 'contexts/AccessibilityContext'
import HeroSection from 'components/home/HeroSection';
import MapCta from 'components/common/MapCta';
import EventList from 'components/home/EventList';
import KiosqueHome from 'components/home/KiosqueHome';
import LiensPratiques from 'components/common/LiensPratiques';
import LiveInfo from 'components/common/LiveInfo';
import styles from './Home.module.css';
import NewsList from 'components/home/NewsList';
import useDocumentTitle from 'hooks/useDocumentTitle'
import { Helmet } from 'react-helmet-async';
import { getDefaultOgImage } from 'utils/ogImageUrl';

const Home = () => {



  const { accessibilityOptions, getAccessibilityVariant } = useContext(AccessibilityContext);

  return (
    <>
      <Helmet>
        <title>Arras | Le site officiel de la ville d'Arras</title>
        <meta name="description" content="Bienvenue sur le site officiel de la Ville d'Arras, préfecture du Pas-de-Calais en région Hauts-de-France : actualité, démarches, agenda, informations pratiques…" />
        <meta property="og:title" content="Ville d'Arras" />
        <meta property="og:description" content="Bienvenue sur le site officiel de la Ville d'Arras, préfecture du Pas-de-Calais en région Hauts-de-France : actualité, démarches, agenda, informations pratiques…" />
        <meta property="og:image" content={getDefaultOgImage()} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="Logo de la ville d'Arras" />
        <meta property="og:url" content="https://www.arras.fr" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Ville d'Arras" />
        {process.env.REACT_APP_FB_APP_ID && (
          <meta property="fb:app_id" content={process.env.REACT_APP_FB_APP_ID} />
        )}
        <link rel="canonical" href="https://www.arras.fr" />
      </Helmet>
      <main className={styles.homePage} aria-label="Page d'accueil de la ville d'Arras">
        {/* Bandeau information */}
        <LiveInfo />

        {/* Section Hero, Recherche et Liens rapides*/}
        <HeroSection />

        <div className="page-content">

          {/* CTA Map */}
          <MapCta />

          {/* Section Agenda */}
          <EventList accessibilityVariant={getAccessibilityVariant()} />
          <NewsList accessibilityVariant={getAccessibilityVariant()} />

          {/* Le Kiosque */}
          <KiosqueHome />

          {/* Liens Pratiques */}
          <LiensPratiques />

        </div>

      </main>
    </>
  );
};

export default Home;
